export function camelCase(str: string) {
  if (typeof str !== 'string') return str
  str = str.charAt(0).toLowerCase() + str.slice(1)
  return str.replace(/[-_](.)/g, function (match, group1) {
    return group1.toUpperCase()
  })
}

export function removeAllSpaces(str: string) {
  if (!str) return ''

  return str.replace(/\s+/g, '')
}

// "[object 型]"から型だけを取り出す。安全に{}だけを"object"として判定できる
function isObject(obj: unknown): obj is Record<string, unknown> {
  return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase() === 'object'
}

export function castAttributesForCamelCase(obj: Record<string, unknown>): Record<string, unknown> {

  const castData: Record<string, unknown> = {}
  for (const record of Object.entries(obj)) {
    const key = record[0]
    let value = record[1]
    if (Array.isArray(value)) {
      value = value.map(v => {
        if (isObject(v)) {
          v = castAttributesForCamelCase(v)
        }
        return v
      })
    } else if (isObject(value)) {
      value = castAttributesForCamelCase(value)
    }
    castData[camelCase(key)] = value
  }
  return castData
}

export const toSnakeCase = (str: string) => {
  return str.split(/(?=[A-Z])/).join('_').toLowerCase()
}

/**
 *
 * @param obj {{}}
 * @return {{}}
 */
export function castAttributesForSnakeCase<T extends Record<string, unknown>>(obj: Record<string, unknown>): T {

  const castData: Record<string, unknown> = {}
  for (const record of Object.entries(obj)) {
    const key = record[0]
    let value = record[1]
    if (Array.isArray(value)) {
      value = value.map(v => {
        if (isObject(v)) return castAttributesForSnakeCase(v)
        return v
      })
    } else if (isObject(value)) {
      value = castAttributesForSnakeCase(value)
    }
    castData[toSnakeCase(key)] = value
  }
  return castData as T
}

export function castCamelToSnake(camel: string) {
  return camel.replace(/[A-Z]/g, searchStr => {
    return '_' + searchStr.charAt(0).toLowerCase()
  })
}

export function castSnakeToCamel(snake: string) {
  return snake.split('_').map((text, index) => {
    if (index === 0) {
      return text.toLowerCase()
    } else {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
    }
  }).join('')
}
